import React from 'react';
import * as css from 'styles'
import { connect } from 'react-redux';
import styled from 'react-emotion'

import View from 'components/View/View';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import FadeIn from '../components/Animated/FadeIn';
import Link from '../components/Link/Link';
import List from '../components/List/List'
import Img from '../components/Img/Img'
import Loading from '../components/Loading/Loading'
import Meta from '../components/Meta/Meta'
import Layout from './Layout'
import Ticker from './Ticker'

import titleFromSlug from 'utils/titleFromSlug';

const PageText = styled(Text)({
  fontSize: '1.2em', //css.font.l,
  lineHeight: '1.3em',
  letterSpacing: '0.025em',

  [css.breakpoint.m_down]: {
    fontSize: '1.2em',
    lineHeight: '1.3em',
  },
  
  '& a':{
    textDecoration: 'underline',
  },

  // CHECK 1_typography.css to change this style - for some reason children + inheritence isn't working right
  
  // '& .client-list': {
  //   listStyle: 'none',
  // },

  // '& .client-list li': {
  //   listStyle: 'none',
  //   display: 'inline-block',
  // },

  // '& .client-list li:after': {
  //   content: ', ',
  //   background: 'green',
  // },

  // '& .client-list li:last-child:after': {
  //   content: '',
  // },
})

const Page = ({ content, status, slug, error }) => {

  const page = (content) ? content[0] : null
  const acf = (page && page.acf) ? page.acf : null
  const metaDescription = acf ? acf.meta_description : null;

  // console.log(content);

  window.scrollTo(0, 0)

  return (page) ? (
    <View padding="0 0 4em 0" style={{maxWidth: '725px', margin: '0 auto'}}>
      <Meta title={error ? 'Page Not Found' : titleFromSlug(slug)} description={metaDescription} />

      <Loading status={status} errormessage="Page Not Found" height="80vh">
      <FadeIn>

        <PageText><span dangerouslySetInnerHTML={{__html: page.content.rendered}} /></PageText>

        {acf.ticker_text && (
          <Ticker>
            {acf.ticker_text}&nbsp;&nbsp;&nbsp;.&nbsp;.&nbsp;.&nbsp;&nbsp;&nbsp;
          </Ticker>
        )}

      </FadeIn>
      </Loading>
    </View>
  ) : null
};

const mapState = state => ({
  slug: state.location.payload.id,
  content: state.page.data,
  status: state.page.status,
  error: state.page.error,
})

export default connect(mapState)(Page);




// WEBPACK FOOTER //
// ./src/containers/Page.js